import styled from 'styled-components';
import { Card } from 'antd';

export const ProductWrapper = styled('span')`
  @media only screen and (max-width: 600px) {
    :not(:first-child) {
      margin: 15px;
    }
    :first-child {
      margin-bottom: 15px;
    }
  }
  @media only screen and (min-width: 600px) {
    margin: 15px;
  }
  border-radius: 5px;
`;

export const CardStyled = styled(Card)`
  :hover {
    opacity: 0.8;
    transition: 200ms;
  }
  -webkit-box-shadow: 1px 2px 8px 1px rgba(0, 0, 0, 0.9);
  box-shadow: 1px 2px 8px 1px rgba(0, 0, 0, 0.8);
  text-align: center;
  width: 250px;
  height: 270px;
  cursor: pointer;
  margin: 0 25px;
  border: 1px solid #1d3e7e;
  background: #fff;
  position: relative;
  border-radius: 5px;
`;
